import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { interpret } from "xstate";
import DeleteComponent from "@/components/deleteComponent.vue";
import { GridOptionModel } from "@/store/models/shared/gridOption";
import automationsMachine from "./machines/automationMachine";
import { AutomationModule } from "@/store/modules/automation.module";
import { setInteractionMode } from "vee-validate";
import { RRule } from "rrule";
import Switches from "vue-switches";
import { EntryModule } from "@/store/modules/entry.module";
import { format } from "date-fns";
import { TextConverter } from "@/helpers/TextConverter";
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let Automations = /** @class */ (() => {
    let Automations = class Automations extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Automations";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Automations",
                    active: true,
                },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.searchData = new GridOptionModel();
            this.automationId = "";
            this.isPageDirty = false;
            this.showArchived = false;
            this.columns = [
                {
                    field: "title",
                    label: "Automation",
                    thClass: "title-name",
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter Automation Name",
                        autoComplete: "off",
                    },
                    sortable: true,
                },
                {
                    field: "savedSearch",
                    label: "Saved Search",
                    sortable: false,
                },
                {
                    field: "users",
                    label: "Organization",
                    sortable: false,
                },
                {
                    field: "recurrenceRule",
                    label: "Recurrence Rule",
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "master-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "title",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.initialSortBy = {
                field: "title",
                type: "asc",
            };
            this.totalCount = 0;
            this.isPageIsDirty = false;
            //   MACHINE
            this.machine = automationsMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            filters.push({
                name: "archived",
                value: `${this.showArchived}`,
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            AutomationModule.AssignSearchParams(searchData);
            this.machineService.send({ type: "GETTING_AUTOMATIONS", searchData: searchData });
        }
        onRowClick(params) {
            var node = params.event.target.nodeName;
            if (node == "A")
                return;
            this.$router.push({
                name: "ViewAutomation",
                params: { automationId: params.row.id },
            });
        }
        toggleShowArchived() {
            this.showArchived = !this.showArchived;
            this.showArchivedAutomations();
        }
        get rows() {
            return AutomationModule.automations;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get automationsCount() {
            return AutomationModule.totalCount;
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get gridParams() {
            return AutomationModule.searchParams;
        }
        clearFilter() {
            this.showArchived = false;
            this.serverParams.columnFilters = {};
            // this.serverParams.page = this.initialPage;
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        showArchiveAutmationModal(id) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.automationId = id;
            this.machineService.send({ type: "ARCHIVE_AUTOMATION", ispageChanged: isPageChanged });
        }
        archiveAutomation() {
            this.machineService.send({ type: "ARCHIVING_AUTOMATION", automationId: this.automationId });
            this.loadItems();
        }
        cancel() {
            this.machineService.send({ type: "CANCEL" });
        }
        sanitizeRule(rule, startDate) {
            if (!rule)
                return "No recurrence rule";
            if (typeof rule === "string") {
                const cleanRule = rule.replace(/\\n/g, "\n");
                let rrule = RRule.fromString(cleanRule);
                let ruleText = rrule.toText();
                const requiredWeekdays = [0, 1, 2, 3, 4];
                const selectedDays = rrule.options.byweekday || [];
                const isWeekdaysOnly = selectedDays.length === 5 && requiredWeekdays.every((day) => selectedDays.includes(day));
                var ruleValue = rrule.options;
                if (isWeekdaysOnly && ruleValue.byweekno) {
                    const weekNumber = ruleValue.byweekno;
                    let weekLabel = TextConverter.ordinalWords.find((w) => w.value.toString() === weekNumber)?.label || "";
                    if (ruleValue.freq === 1) {
                        let baseText = `every ${ruleValue.interval > 1 ? ruleValue.interval + " " : ""}${ruleValue.interval === 1 ? "month," : "months,"} on the ${weekLabel}Mon, ${weekLabel}Tue, ${weekLabel}Wed, ${weekLabel}Thu and ${weekLabel}Fri`;
                        // Add until/after information
                        if (ruleValue.until) {
                            const untilDate = new Date(ruleValue.until);
                            baseText += ` until ${format(untilDate, "MMM d, yyyy")}`;
                        }
                        else if (ruleValue.count > 0) {
                            baseText += ` after ${ruleValue.count} occurrences`;
                        }
                        ruleText = baseText + ".";
                    }
                }
                else if (isWeekdaysOnly) {
                    if (ruleValue.freq === 2) {
                        ruleText = ruleText.replace(/every weekday/g, "every week on weekdays");
                    }
                }
                if (ruleValue.interval == 1) {
                    ruleText = ruleText.replace(/every day/g, "every week on every day");
                }
                ruleText = TextConverter.removeDuplicateAndPhrase(ruleText);
                if (ruleValue.freq === 1 && ruleValue.bynmonthday.includes(-1)) {
                    ruleText = ruleText.replace(/last/g, "last date");
                }
                if (ruleValue.freq === 2) {
                    ruleText = ruleText.replace(/weeks days/g, "weeks on every day");
                }
                // Convert weekdays and months to short form
                ruleText = TextConverter.convertWeekdaysToShortForm(ruleText);
                ruleText = TextConverter.convertMonthsToShortForm(ruleText);
                return `${startDate} ${ruleText}`;
            }
            return "Invalid recurrence rule";
        }
        getOrdinalSuffix(day) {
            if (day > 3 && day < 21)
                return day + "th";
            switch (day % 10) {
                case 1:
                    return day + "st";
                case 2:
                    return day + "nd";
                case 3:
                    return day + "rd";
                default:
                    return day + "th";
            }
        }
        showArchivedAutomations() {
            this.initialPage = 1;
            this.serverParams.page = this.initialPage;
            this.loadItems();
        }
        getSearchDetails(id) {
            EntryModule.GetSearchDetail(id).then((res) => {
                if (res) {
                    this.$router.push({ name: "EntryListing" });
                }
            });
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "ViewAutomation" && from.name != "EntryListing") {
                AutomationModule.ClearSearchParams();
            }
            next();
        }
        initialize() {
            var value = AutomationModule.searchParams;
            if (value != null) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                var archived = value.columnFilters.filter((item) => item.name == "archived");
                value.columnFilters = value.columnFilters.filter((item) => item.name != "archived");
                if (value.columnFilters.length > 0) {
                    value.columnFilters.forEach((item) => {
                        this.serverParams.columnFilters[item.name] = item.value;
                    });
                }
                this.showArchived = JSON.parse(archived[0].value.toLowerCase());
                this.initialSortBy = value.sort;
            }
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.gridParams.columnFilters.forEach((item) => {
                    this.isPageDirty = true;
                    gridColumns[item.name] = item.value;
                });
            }
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (previousState.matches("idle") && this.state.matches("gettingAutomations")) {
                    this.assignColumnFilters();
                }
                if (this.state.matches("loadedAutomations")) {
                    this.totalCount = this.automationsCount;
                    this.isPageDirty = false;
                }
                if (this.state.matches("gettingAutomations") && previousState.matches("loadedAutomations.archivingAutomation")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Automations = __decorate([
        Component({
            name: "Automations",
            components: {
                Layout,
                PageHeader,
                EcGrid,
                DeleteComponent,
                Switches,
            },
        })
    ], Automations);
    return Automations;
})();
export default Automations;
